<template>
  <div class="public-View">
    <div class="public-goback">
      <img alt :src="g_imgSrc.rightArrow" class="public-goback-img" @click="goback" />
      <div class="public-goback-return" @click="goback">返回</div>
    </div>
    <div style="margin-top: 40px">
      <div class="filter-container">
        <div class="filter-container-left">
          <div>题库：</div>
          <div>
            <el-select v-model="examBank" multiple placeholder="根据题库筛选" style="width: 200px">
              <el-option
                v-for="item in examBankList"
                :key="item.bank_id"
                :label="item.bank_name"
                :value="item.bank_id"
              ></el-option>
            </el-select>
          </div>
          <div>题目类型：</div>
          <div>
            <el-select v-model="questionType" placeholder="根据类型筛选" style="width: 200px">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-container-right">
          <el-button type="primary" @click="handleFilter">筛选</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="questionList" style="width: 100%" v-loading="loading">
        <el-table-column width="55">
          <template slot="header" slot-scope="scope">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="tableSelectAll"
              @change="handleSelectAll(scope)"
            ></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.isChecked"
              @change="handleSelectionChange(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="题目名称">
          <template slot-scope="scope">
            <ellipsis :expandable="true" :str="scope.row.question_name"></ellipsis>
          </template>
        </el-table-column>
        <el-table-column prop="call_num" label="调用次数"></el-table-column>
        <el-table-column prop="answered_num" label="已答人数"></el-table-column>
        <el-table-column label="正确率">
          <template slot-scope="scope">
            <span>{{ `${scope.row.accuracy}%` }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="question_type" label="题目类型">
          <template slot-scope="scope">
            <span>{{ convertQuestionNumToStr(scope.row.question_type) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          style="float: right"
          @size-change="changeSize"
          @current-change="changeIndex"
          :current-page="pageIndex"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
      <div style="margin: 40px 0 0 40px">
        <el-button @click="addQuestions(false)">取消</el-button>
        <el-button type="primary" @click="addQuestions(true)">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetQuestionList } from '@/api/exam';
import { GetQuestionBankList } from '@/api/examBankManagement';
import ellipsis from '@/components/ellipsis/index';
import { lstore } from '@/libs/utils/util';

export default {
  name: 'AddQuestion',
  components: {
    ellipsis,
  },
  data() {
    return {
      paper_id: this.$route.query.paper_id,
      loading: false,
      examBank: [],
      examBankList: [],
      questionType: undefined,
      options: [
        {
          value: 0,
          label: '全部',
        },
        {
          value: 1,
          label: '单选',
        },
        {
          value: 2,
          label: '多选',
        },
      ],
      questionList: [], // 题目列表
      tableSelectAll: false, // 全选
      isIndeterminate: false, // 全选样式控制
      tableSelection: [], // 当前表中的选择id数组
      selectedQuestionIdList: [], // 所有已选题目id列表
      pageIndex: 1,
      pageTotal: 1,
      pageSize: 10,
      onLoading: false,
      paperToQuestions: {},
    };
  },
  mounted() {
    // 设置面包屑
    this.g_breadcrumb([
      { menu_name: '考试管理', menu_path: '' },
      { menu_name: '试卷管理', menu_path: 'examPaperManagement' },
      {
        menu_name: '新建考卷',
        menu_path: 'examPaperManagement',
        menu_params: { componentName: 'addPaper' },
      },
      { menu_name: '添加题目' },
    ]);
  },
  created() {
    // 查询题库列表
    GetQuestionBankList({
      page_index: 1,
      page_size: 999,
    }).then((res) => {
      this.examBankList = res.bank_list;
    });

    // 读取localStorage中的已选题目（如果有的话）
    this.paperToQuestions = lstore.getItem('exam-paper-add-question-ids') || {};
    const ids = this.paperToQuestions.ids || [];
    if (ids.length !== 0) {
      this.selectedQuestionIdList = ids;
    }

    // 查询题目列表
    this.getQuestionList();
  },
  methods: {
    goback() {
      this.$emit('changeComponent', 'addPaper', { paper_id: this.paper_id, type: 'back' });
    },
    changeIndex(index) {
      this.pageIndex = index;
      this.onLoading = true; // 用于向选择改变设立sign，在handleSelectAll中改为false
      this.getQuestionList();
    },
    changeSize(size) {
      this.pageSize = size;
      this.resetPageIndex();
      this.getQuestionList();
    },
    resetPageIndex() {
      this.changeIndex(1);
    },
    convertQuestionNumToStr(questionTypeNum) {
      switch (questionTypeNum) {
        case 1:
          return '单选';
        case 2:
          return '多选';
        default:
          return '参数错误';
      }
    },
    handleShowSelection() {
      this.questionList.forEach((row) => {
        if (this.selectedQuestionIdList.includes(row.question_id)) {
          this.$set(row, 'isChecked', true);
        } else {
          this.$set(row, 'isChecked', false);
        }
      });
    },
    getQuestionList() {
      this.loading = true;
      GetQuestionList({
        page_index: this.pageIndex,
        page_size: this.pageSize,
        // 只选择一个：1（单选）2（多选），两个都选为0（全选）
        question_type: this.questionType,
        bank_list: this.examBank,
        question_name: '',
      }).then((res) => {
        this.questionList = res.question_list;
        this.pageTotal = res.total;
        this.handleShowSelection();
        this.checkIndeterminate();
        this.loading = false;
      });
    },
    handleFilter() {
      // 筛选函数
      this.resetPageIndex();
      this.getQuestionList();
    },
    handleSelectAll() {
      if (this.tableSelectAll) {
        // 全选
        for (const item of this.questionList) {
          if (!this.selectedQuestionIdList.includes(item.question_id)) {
            this.selectedQuestionIdList.push(item.question_id);
            item.isChecked = true;
          }
        }
      } else {
        for (const item of this.questionList) {
          if (this.selectedQuestionIdList.includes(item.question_id)) {
            this.selectedQuestionIdList.splice(
              this.selectedQuestionIdList.indexOf(item.question_id),
              1,
            );
            item.isChecked = false;
          }
        }
      }
      this.isIndeterminate = false;
    },
    checkIndeterminate() {
      const checked = this.questionList.filter((item) => {
        return item.isChecked;
      });
      this.isIndeterminate = !(checked.length === this.pageSize || checked.length === 0);
    },
    handleSelectionChange(row) {
      console.log(row);
      if (row.isChecked) {
        // 添加了新题目
        if (!this.selectedQuestionIdList.includes(row.question_id)) {
          this.selectedQuestionIdList.push(row.question_id);
        }
      } else {
        // 删除题目
        if (this.selectedQuestionIdList.includes(row.question_id)) {
          this.selectedQuestionIdList.splice(
            this.selectedQuestionIdList.indexOf(row.question_id),
            1,
          );
        }
      }
      console.log(this.selectedQuestionIdList);
      this.checkIndeterminate();
    },
    addQuestions(save) {
      if (save) {
        this.paperToQuestions.ids = this.selectedQuestionIdList;
        lstore.setItem('exam-paper-add-question-ids', this.paperToQuestions);
      }
      this.goback();
    },
  },
};
</script>

<style scoped lang="scss">
.public-View {
  width: 100%;
  // height: 100%;
  // padding: 0 24px;
  position: relative;
  overflow: auto;
  .public-goback {
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #303133;
    .public-goback-img {
      position: absolute;
      top: 12.5px;
      left: 0;
      width: 24px;
      height: 24px;
      transform: rotateY(180deg);
    }
    .public-goback-return {
      position: absolute;
      top: 17px;
      width: 44px;
      height: 22px;
      left: 28px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #606266;
      letter-spacing: 0;
      cursor: pointer;
    }
    .public-goback-return:hover {
      color: rgb(47, 150, 255);
    }
  }
  .filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
  }
  .filter-container-left {
    div {
      display: inline-block;
      margin: 0 10px;
    }
  }
}
</style>
